import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 20px 0;
`;
